import { useEffect, useState } from 'react';

// Internal Imports
import ModalContainer from '../../common/components/ModalContainer/ModalContainer';
import { IUserInformation } from '../../interfaces/IUser';
import './Usuarios.css';
import ContentStepper from '../../common/components/ContentStepper.tsx/ContentStepper';
import StepOne from './FormSteps/StepOne';
import StepTwo from './FormSteps/StepTwo';
import StepThree from './FormSteps/StepThree';
import StepFour from './FormSteps/StepFour';
import StepFive from './FormSteps/StepFive';
import { useForm } from '../../contexts/form';
import { Mode } from '../../common/types/AllTypes';
import { InsertUser, updateUser } from '../../services/user';
import { fakeUser, getCopyOf, getError, openNotification, tryCatch } from '../../common/constants/Utilities';
import { Step } from '../../interfaces/IStep';

interface Props {
    mode: Mode;
    setMode: React.Dispatch<React.SetStateAction<Mode>>;
    setAddUpdateModal: React.Dispatch<React.SetStateAction<boolean>>;
    setDataList: (list: IUserInformation[]) => void;
    dataList: IUserInformation[]
}

const AddUpdateUser = ({ mode, setMode, setAddUpdateModal, setDataList, dataList }: Props) => {

    // States
    const { setUserInformationForm, statusUserForm, userInformationForm, loadingSubmit, setLoadingSubmit } = useForm();
    const [canGoNext, setCanGoNext] = useState<boolean>(false);
    const [canGoBack, setCanGoBack] = useState<boolean>(false);


    // Methods
    const goToUpdate = (user: IUserInformation) => {
        setMode('Update');
        setUserInformationForm(user);
    }

    const reviewFormBeforeSending = (form: IUserInformation) => {
        const formClone = getCopyOf(form);

        if (!form.usuarioProyecto?.fechaHasta) {
            form.usuarioProyecto!.fechaHasta = null;
        }

        form.usuarioProyecto?.usuarioProyectoRol.forEach(rol => {
            if (!rol.fechaHasta) {
                rol.fechaHasta = null;
            }
        })

        return formClone;
    }

    // Handles
    const handleSubmit = () => {
        setLoadingSubmit(true);

        const formReviewed = reviewFormBeforeSending(userInformationForm!);

        tryCatch(() => {
            if (mode === 'Add') {
                InsertUser(formReviewed)
                    .then((response) => {
                        openNotification('success', `Usuario agregado`, response.msg!);
                        setAddUpdateModal(false);

                        // reset Table
                        let dataListInternal = dataList;
                        dataListInternal.push(response.data);
                        setDataList([...dataListInternal]);
                        //


                    })
                    .catch((response) => {
                        openNotification('error', 'Error', getError(response?.msg));
                    })
                    .finally(() => setLoadingSubmit(false));
            } else {
                updateUser(formReviewed)
                    .then((response) => {
                        openNotification('success', `Usuario Modificado`, response.msg!);
                        setUserInformationForm(response.data);
                        setAddUpdateModal(false);

                        // reset Table
                        let result: IUserInformation = response.data;
                        let dataListInternal = dataList;

                        let index = dataList.findIndex(x => x.usuarioGUID === result.usuarioGUID);
                        dataListInternal[index] = result;
                        setDataList([...dataListInternal]);
                        //
                    })
                    .catch((response) => {
                        openNotification('error', 'Error', getError(response?.msg));
                    })
                    .finally(() => setLoadingSubmit(false));
            }
        })
    }



    // Const

    let ConstSteps = [
        {
            title: '¿Existe el usuario en otro proyecto?',
            content: <StepOne setCanGoNext={setCanGoNext} goToUpdate={goToUpdate} />,
        },
        {
            title: 'Información General',
            content: <StepTwo mode={mode} setCanGoNext={setCanGoNext} setCanGoBack={setCanGoBack}/>,
        },
        {
            title: 'Información Organizacional',
            content: <StepThree mode={mode} setCanGoNext={setCanGoNext} setCanGoBack={setCanGoBack} />,
        },
        {
            title: 'Roles',
            content: <StepFour mode={mode} setCanGoNext={setCanGoNext} setCanGoBack={setCanGoBack} />,
        },
        {
            title: 'Atributos genéricos',
            content: <StepFive mode={mode} setCanGoBack={setCanGoBack} />,
        }
    ];

    // States
    const [steps, setSteps] = useState<Step[]>(mode === 'Add' ? ConstSteps : ConstSteps.slice(1));

    // Effects
    useEffect(() => {
        if (mode === 'Add') {
            setSteps(ConstSteps);
            setUserInformationForm(getCopyOf(fakeUser));
        } else {
            setSteps(ConstSteps.slice(1));
        }
    }, [mode]);

    return (
        <ModalContainer style={{ height: '87vh' }}>
            <ContentStepper mode={mode} canSubmit={statusUserForm} loadingSubmit={loadingSubmit} steps={steps} canGoBack={canGoBack} canGoNext={canGoNext} method={() => handleSubmit()} />
        </ModalContainer>
    )

}

export default AddUpdateUser;
